import { CARD_BRAND, SecureCreditCard } from '../models/entities/SecureCreditCard';
import { SecureCreditCardResponse } from '../models/responses/UserResponse';

export const secureCreditCardsTranslator = (responses: SecureCreditCardResponse[]): SecureCreditCard[] => {
  return responses.map((response) => ({
    id: response.id,
    brand: response.brand as CARD_BRAND,
    lowerFourDigits: response.lower_four_digits,
    expMonth: response.exp_month,
    expYear: response.exp_year,
    holderName: response.holder_name,
    primary: response.primary,
  }));
};
